;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:locale/impersonate\",\"regex\":\"^/([^/]+)/impersonate$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/login\",\"regex\":\"^/([^/]+)/login$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/sign-up\",\"regex\":\"^/([^/]+)/sign-up$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/:rest*?\",\"regex\":\"^/([^/]+)(?:/(.*))?$\",\"paramNames\":[\"locale\",\"rest\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/not-authorized\",\"regex\":\"^/([^/]+)/not-authorized$\",\"paramNames\":[\"locale\"],\"hasOptionalPrefix\":true},{\"path\":\"/:locale/admin/:rest*?\",\"regex\":\"^/([^/]+)/admin(?:/(.*))?$\",\"paramNames\":[\"locale\",\"rest\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.1";import * as Sentry from '@sentry/nextjs';

// TODO: Remove this workaround - use NEXT_PUBLIC variables when they will be available in all environment.
const publicEnvironmentVariables = window.PUBLIC_ENV;

Sentry.init({
  debug: false,
  dsn: publicEnvironmentVariables?.sentryDSN,
  enabled: publicEnvironmentVariables?.appEnvironment !== 'LOCAL',
  enableLogs: publicEnvironmentVariables?.appEnvironment !== 'LOCAL',
  environment: publicEnvironmentVariables?.appEnvironment,
  ignoreErrors: [
    'Hydration Error',
    "Hydration failed - the server rendered HTML didn't match the client.",
    "Failed to execute 'getComputedStyle' on 'Window'",
    /AADB2C90080/u,
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({
      blockAllMedia: true,
      maskAllText: false,
    }),
  ],
  replaysOnErrorSampleRate: 1,
  replaysSessionSampleRate: 0.05,
  skipOpenTelemetrySetup: true,
  tracesSampleRate: 0.05,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
